import {
  BusinessCardType,
  FetchBusinessCardsFailureAction,
  FetchBusinessCardsRequestAction,
  FetchBusinessCardsSuccessAction,
  SalaryCardActions,
  SalaryCardActionTypes,
} from 'store/types/salaryCard'
import { Dispatch } from 'redux'
import { fetchBusinessCardsService } from '../../../services/SalaryCards/salaryCards'
import { setGlobalErrorAction } from '../globalError'
import { GlobalErrorActions } from 'store/types/globalError'

export const fetchBusinessCardsRequest =
  (): FetchBusinessCardsRequestAction => ({
    type: SalaryCardActionTypes.FETCH_BUSSINESS_CARDS_REQUEST,
  })

export const fetchBusinessCardsSuccess = (
  businessCardsList: BusinessCardType[]
): FetchBusinessCardsSuccessAction => ({
  type: SalaryCardActionTypes.FETCH_BUSSINESS_CARDS_SUCCESS,
  payload: businessCardsList,
})

export const fetchBusinessCardsFailure = (
  error: any
): FetchBusinessCardsFailureAction => ({
  type: SalaryCardActionTypes.FETCH_BUSSINESS_CARDS_FAILURE,
  payload: error,
})

export const fetchBusinessCards = (currency: string) => {
  return async (dispatch: Dispatch<SalaryCardActions | GlobalErrorActions>) => {
    dispatch(fetchBusinessCardsRequest())

    try {
      const data = await fetchBusinessCardsService(currency)
      dispatch(fetchBusinessCardsSuccess(data))
    } catch (error) {
      dispatch(fetchBusinessCardsFailure(error.message))
      // dispatch(setGlobalErrorAction(error.message ?? ''));
    }
  }
}
